import { Decimal } from "decimal.js";
export class TermInterestRateOverride {
    _termNumber;
    jsTermNumber;
    _interestRate;
    jsInterestRate;
    _active = true;
    jsActive = true;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.interestRate = params.interestRate;
        if (params.active !== undefined)
            this.active = params.active;
    }
    /* ── active flag ─────────────────────────────────────────────── */
    get active() {
        return this._active;
    }
    set active(val) {
        this._active = val;
        this.jsActive = val;
    }
    /* ── term # ──────────────────────────────────────────────────── */
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(val) {
        this._termNumber = val;
        this.jsTermNumber = val;
    }
    /* ── rate ────────────────────────────────────────────────────── */
    get interestRate() {
        return this._interestRate;
    }
    set interestRate(val) {
        if (!(val instanceof Decimal)) {
            val = new Decimal(val);
        }
        this._interestRate = val;
        this.jsInterestRate = val.toNumber();
    }
    /* ── sync helpers for Angular forms ─────────────────────────── */
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.interestRate = new Decimal(this.jsInterestRate);
        this.active = this.jsActive;
    }
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsInterestRate = this.interestRate.toNumber();
        this.jsActive = this.active;
    }
    get json() {
        return {
            termNumber: this.termNumber,
            interestRate: this.interestRate.toNumber(),
            active: this.active,
        };
    }
}
